import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_waitlist-system-5/artifacts/dxfo1yhd_Logo-03.png" 
            alt="Valenrock Home Services" 
            className="h-20 w-auto mx-auto"
          />
        </div>

        {/* 404 Text */}
        <h1 className="text-9xl font-bold text-[#003366] mb-4">404</h1>
        
        {/* Message */}
        <h2 className="text-3xl font-bold text-[#003366] mb-4">
          Page Not Found
        </h2>
        <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/">
            <Button size="lg" className="bg-[#003366] hover:bg-[#003366]/90 text-white px-8">
              <Home className="mr-2" size={20} />
              Go to Homepage
            </Button>
          </Link>
          <Button 
            size="lg" 
            variant="outline" 
            onClick={() => window.history.back()}
            className="border-[#003366] text-[#003366] hover:bg-[#003366] hover:text-white px-8"
          >
            <ArrowLeft className="mr-2" size={20} />
            Go Back
          </Button>
        </div>

        {/* Helpful Links */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4">Looking for something?</p>
          <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
            <Link to="/services" className="text-[#003366] hover:underline">
              Our Services
            </Link>
            <span className="text-gray-300">•</span>
            <Link to="/assessment" className="text-[#003366] hover:underline">
              Home Assessment
            </Link>
            <span className="text-gray-300">•</span>
            <Link to="/contact" className="text-[#003366] hover:underline">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
